import React, { useEffect, useMemo } from "react";
import "./style.scss";
import BaseLayout from "../../components/Layout";
import { getUser } from "../../helpers/user";
import { useAppSelector } from "../../hooks/useAppSelector";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import {
  actionGetAlertasProperty,
  updateAlertasPropertyData,
} from "../../features/alertas/getAll-alertas/slices";
import conectSocket from "../../helpers/connect-socket";
import {
  actionGetPontosMonitoriaByLoja,
  actionGetPontosMonitoriaByRegional,
} from "../../features/monitoramento/lista-pontos/slices";
import { actionGetPontosMonitoriaGeral } from "../../features/getPontosMonitoramentoPorCliente/slices";
import { actionGetDashboardGeral } from "../../features/dashboard-geral/slices";
import MapaGoogle from "../../components/MapaGoogle";
import { LoaderCircle } from "lucide-react";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { actionGetAlertasAbertos } from "../../features/alertas/slices";

ChartJS.register(ArcElement, Tooltip, Legend);

// ==========================================
// 🎨 ÍCONES DOS CARDS
// ==========================================
const IconSetores = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="7" height="7" />
    <rect x="14" y="3" width="7" height="7" />
    <rect x="14" y="14" width="7" height="7" />
    <rect x="3" y="14" width="7" height="7" />
  </svg>
);
const IconRiscos = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);
const IconCaixaFerramentas = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
  </svg>
);
const IconPontosMonitoria = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

const PageProperty = () => {
  const dispatch = useAppDispatch();
  const user = getUser();

  const lojaSelected = useAppSelector((state) => state.getLojas.lojaSelected);
  const regionalSelected = useAppSelector(
    (state) => state.getRegionais.regionalSelected,
  );
  const lojas = useAppSelector((state) => state.getLojas.lojas);

  const idRegionalUser = 1;
  const idCliente = user?.usuario?.idCliente as number;

  const currentIdLoja = lojaSelected ? Number(lojaSelected) : 0;
  const currentIdRegional = regionalSelected ? Number(regionalSelected) : 0;

  // Selectors
  const { data: metrics, status } = useAppSelector(
    (state) => state.getAlertasProperty,
  );
  const alertasAbertos = useAppSelector((state) => state.getAlertasAbertos);
  const getDashboardGeral = useAppSelector(
    (state) => state.getDashboardGeral,
  ) as any;
  const pontosMonitoriaByLoja = useAppSelector(
    (state) => state.pontosMonitoriaByLoja,
  );
  const pontosMonitoriaGeral = useAppSelector(
    (state) => state.getPontosMonitoriaGeral,
  );

  console.log("AlertasAbertos: ", alertasAbertos);

  const loading = status === "loading";

  // ==========================================
  // 🧮 CÁLCULOS E TRATAMENTOS
  // ==========================================
  const totalPontosMonitoria = useMemo(() => {
    const dataSource =
      currentIdLoja > 0 ? pontosMonitoriaByLoja : pontosMonitoriaGeral;
    const grupos = dataSource?.data?.grupoMonitor;
    if (!grupos || !Array.isArray(grupos)) return 0;

    return grupos.reduce((acc: number, grupo: any) => {
      return (
        acc +
        (grupo.listaMonA?.length || 0) +
        (grupo.listaMonD?.length || 0) +
        (grupo.listaMonR?.length || 0)
      );
    }, 0);
  }, [pontosMonitoriaByLoja, pontosMonitoriaGeral, currentIdLoja]);

  const loadingPontos =
    currentIdLoja > 0
      ? pontosMonitoriaByLoja.status === "loading"
      : pontosMonitoriaGeral.status === "loading";

  const statusBrasilTratado = useMemo(() => {
    const mapaOriginal = getDashboardGeral?.data?.mapaBrasil;
    if (!mapaOriginal || !Array.isArray(mapaOriginal)) return {};

    return mapaOriginal.reduce((acc: any, item: any) => {
      if (item?.sigla) acc[item.sigla.toLowerCase()] = item.status;
      return acc;
    }, {});
  }, [getDashboardGeral?.data?.mapaBrasil]);

  // ==========================================
  // 🔌 EFEITOS E SOCKETS
  // ==========================================
  const handleSocketUpdate = React.useCallback(
    (data: any) => {
      dispatch(updateAlertasPropertyData(data));
    },
    [dispatch],
  );

  useEffect(() => {
    let connection: any = null;

    dispatch(
      actionGetAlertasAbertos({
        idLoja: lojaSelected ? Number(lojaSelected) : 0,
        pagina: 1, // ← Passe para o seu slice/payload da Action
        itensPorPagina: 20, // ← Passe para o seu slice/payload da Action
      }),
    );

    if (idRegionalUser && idCliente) {
      dispatch(
        actionGetAlertasProperty({
          idLoja: currentIdLoja,
          idCliente: idCliente,
        }),
      );

      dispatch(actionGetDashboardGeral());

      if (currentIdRegional > 0) {
        dispatch(actionGetPontosMonitoriaByRegional(currentIdRegional));
      } else if (currentIdLoja > 0) {
        dispatch(actionGetPontosMonitoriaByLoja(currentIdLoja));
      } else {
        dispatch(actionGetPontosMonitoriaGeral());
      }

      connection = conectSocket({
        url: "hubProperty",
        hub: "PropertyDados",
        cb: handleSocketUpdate,
        params: { idLoja: currentIdLoja, idRegional: currentIdRegional },
      });
    }

    return () => {
      if (connection) connection.stop();
    };
  }, [
    currentIdLoja,
    handleSocketUpdate,
    idRegionalUser,
    idCliente,
    dispatch,
    currentIdRegional,
  ]);

  // ==========================================
  // 📊 GRÁFICO DOUGHNUT
  // ==========================================
  const valorBrutoImportancia = useMemo(() => {
    const valor =
      currentIdLoja > 0
        ? metrics.importanciaSeguradaLoja
        : currentIdRegional > 0
          ? metrics.importanciaSeguradaRegional
          : metrics.importanciaSegurada;
    return Number(valor) || 0;
  }, [currentIdLoja, currentIdRegional, metrics]);

  const valorFormatadoImportancia = useMemo(() => {
    return valorBrutoImportancia.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }, [valorBrutoImportancia]);

  const dadosGraficoGauge = useMemo(() => {
    const maxEscala6Bi = 6000000000;
    const valorAtual = Math.min(valorBrutoImportancia, maxEscala6Bi);
    return {
      datasets: [
        {
          data: [valorAtual, maxEscala6Bi - valorAtual],
          backgroundColor: ["#ff9f43", "#cbd5e1"],
          borderWidth: 0,
        },
      ],
    };
  }, [valorBrutoImportancia]);

  const opcoesGraficoGauge = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 2,
    rotation: -90,
    circumference: 180,
    cutout: "75%",
    plugins: { legend: { display: false }, tooltip: { enabled: false } },
  };

  const listaAlertasDireita = useMemo(() => {
    if (!alertasAbertos?.data || !Array.isArray(alertasAbertos.data)) return [];

    const nivelUsuario = user?.usuario?.nivel;

    return alertasAbertos.data.filter((item: any) => {
      const desc = (item.descricao || "").toLowerCase();
      const isTecnico =
        desc.includes("encontra-se offline") || desc.includes("offline");

      // Se for um alerta técnico/offline e o usuário NÃO for nível 9 (Íkone), esconde
      if (isTecnico && nivelUsuario !== 999) {
        return false;
      }

      return true;
    });
  }, [alertasAbertos?.data, user?.usuario?.nivel]);

  return (
    <BaseLayout>
      <div className="page-property-container">
        <aside className="property-aside">
          <div
            style={{
              color: "white",
              borderBottom: "1px solid #334155",
              paddingBottom: "10px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <img src={user?.usuario?.logoIkone} alt="" />
            <img src={user?.customCliente?.imgLogotipo} alt="" />
          </div>

          <div className="prop-metrics-vertical">
            <div className="prop-mini-card">
              <div className="card-header">
                <IconRiscos />{" "}
                <span className="card-header__label">Clientes</span>
              </div>
              <span className="prop-mini-card__value">
                {loading ? (
                  <LoaderCircle className="loader" size={18} />
                ) : (
                  metrics?.quantidadeClientes || 0
                )}
              </span>
            </div>

            <div className="prop-mini-card">
              <div className="card-header">
                <IconSetores />{" "}
                <span className="card-header__label">Locais</span>
              </div>
              <span className="prop-mini-card__value">
                {loading ? (
                  <LoaderCircle className="loader" size={18} />
                ) : (
                  metrics?.quantidadeLojas || 0
                )}
              </span>
            </div>

            <div className="prop-mini-card">
              <div className="card-header">
                <IconSetores />{" "}
                <span className="card-header__label">Centrais</span>
              </div>
              <span className="prop-mini-card__value">
                {loading ? (
                  <LoaderCircle className="loader" size={18} />
                ) : (
                  metrics?.quantidadeCentrais || 0
                )}
              </span>
            </div>

            <div className="prop-mini-card">
              <div className="card-header">
                <IconPontosMonitoria />{" "}
                <span className="card-header__label">Pontos</span>
              </div>
              <span className="prop-mini-card__value">
                {loadingPontos ? (
                  <LoaderCircle className="loader" size={18} />
                ) : (
                  totalPontosMonitoria
                )}
              </span>
            </div>

            <div className="prop-mini-card">
              <div className="card-header">
                <IconCaixaFerramentas />{" "}
                <span className="card-header__label">Para Tratar</span>
              </div>
              <span className="prop-mini-card__value">
                {loading ? (
                  <LoaderCircle className="loader" size={18} />
                ) : (
                  metrics?.paraTratamento || 0
                )}
              </span>
            </div>

            <div className="prop-mini-card">
              <div className="card-header" style={{ color: "#c32e42" }}>
                <IconCaixaFerramentas />{" "}
                <span className="card-header__label">Ocorrências 30d</span>
              </div>
              <span className="prop-mini-card__value">
                {loading ? (
                  <LoaderCircle className="loader" size={18} />
                ) : (
                  metrics?.ocorrencias30d || 0
                )}
              </span>
            </div>

            <div className="prop-mini-card">
              <div className="card-header" style={{ color: "#10b981" }}>
                <IconCaixaFerramentas />{" "}
                <span className="card-header__label">Tratadas 30d</span>
              </div>
              <span className="prop-mini-card__value">
                {loading ? (
                  <LoaderCircle className="loader" size={18} />
                ) : (
                  metrics?.tratadas30d || 0
                )}
              </span>
            </div>
          </div>

          <div
            style={{
              marginTop: "auto",
              background: "white",
              padding: "1.2rem 1rem",
              borderRadius: 8,
              border: "1px solid #cbd5e1",
            }}
          >
            <h4
              style={{
                color: "#1e293b",
                fontSize: "0.9rem",
                marginBottom: "1rem",
                textAlign: "center",
              }}
            >
              Importância Segurada
            </h4>

            <div
              className="prop-gauge-container"
              style={{
                position: "relative",
                width: "100%",
                maxWidth: "200px",
                margin: "0 auto",
              }}
            >
              <Doughnut data={dadosGraficoGauge} options={opcoesGraficoGauge} />

              <div
                style={{
                  position: "absolute",
                  bottom: "-5px", // 👈 Move o texto para baixo, tirando de cima da linha
                  left: 0,
                  width: "100%",
                  textAlign: "center",
                  fontWeight: 800,
                  fontSize: "0.85rem", // 👈 Fonte menor para caber textos grandes
                  color: "#1e293b",
                }}
              >
                {valorFormatadoImportancia}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "0.75rem",
                fontWeight: 700,
                color: "#64748b",
                marginTop: "1rem",
              }}
            >
              <span>R$ 0 Bi</span>
              <span>R$ 6 Bi</span>
            </div>
          </div>
        </aside>

        <main className="property-center-map">
          <MapaGoogle
            status={statusBrasilTratado}
            lojasMapa={getDashboardGeral?.data?.lojasMapa || []}
            zoom={4}
            tipoMapa="roadmap"
            tema="light"
            fillScreen={true}
          />
        </main>

        <aside className="property-aside">
          <div
            style={{
              color: "white",
              borderBottom: "1px solid #334155",
              paddingBottom: "10px",
            }}
          >
            <h2 style={{ fontSize: "1.2rem", margin: 0 }}>Últimos Alertas</h2>
          </div>

          {alertasAbertos?.status === "loading" ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "2rem",
              }}
            >
              <LoaderCircle
                className="loader"
                size={24}
                style={{ color: "white" }}
              />
            </div>
          ) : !listaAlertasDireita || listaAlertasDireita.length === 0 ? (
            <p
              style={{
                color: "#94a3b8",
                textAlign: "center",
                marginTop: "2rem",
                fontSize: "0.85rem",
              }}
            >
              Nenhum evento em andamento
            </p>
          ) : (
            <div
              className="prop-feed-scroll"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
                width: "100%",
              }}
            >
              {listaAlertasDireita.map((alerta: any, idx: number) => (
                <div
                  key={idx}
                  style={{
                    background: "white",
                    padding: "0.75rem",
                    borderRadius: 8,
                    borderLeft: "4px solid #c32e42",
                  }}
                >
                  <strong
                    style={{
                      color: "#c32e42",
                      fontSize: "0.85rem",
                      display: "block",
                      marginBottom: "0.2rem",
                    }}
                  >
                    {alerta.loja?.nome || `Loja ${alerta.idLoja}`}
                  </strong>
                  <p
                    style={{
                      margin: "0.4rem 0",
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      color: "#1e293b",
                      lineHeight: "1.3",
                    }}
                  >
                    {alerta.descricao}
                  </p>
                  <small
                    style={{
                      color: "#64748b",
                      fontWeight: 700,
                      fontSize: "0.7rem",
                      display: "block",
                      textAlign: "right",
                      marginTop: "0.2rem",
                    }}
                  >
                    {alerta.dataEvento
                      ? new Date(alerta.dataEvento).toLocaleString("pt-BR")
                      : ""}
                  </small>
                </div>
              ))}
            </div>
          )}
        </aside>
      </div>
    </BaseLayout>
  );
};

export default PageProperty;
